// noinspection HtmlUnknownAttribute

import React, {useState} from 'react'
import Backdrop from '@mui/material/Backdrop'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import {Stack} from '@mui/material'
import Box from '@mui/material/Box'
import useAcceptModal from '@/hooks/modalAccept'
import Firework from '@/components/Modals/Firework'

interface ModalTranslationProps {
  children: any
  zIndex?: number | undefined
  onClose?: () => void
  closable?: boolean
  firework?: boolean
  styles?: {[key: string]: string}
  stylesContainer?: {[key: string]: string}
}

const ModalTranslation = ({
  children,
  onClose,
  closable = true,
  styles,
  stylesContainer,
  zIndex,
  firework = false,
}: ModalTranslationProps) => {
  const {hideAcceptModal} = useAcceptModal()
  const [open, setOpen] = useState(true)

  let style = {
    minWidth: 360,
    maxWidth: 700,
    bgcolor: 'background.paper',
    boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.08)',
    borderRadius: 5,
    overflow: 'auto',
    wordBreak: 'break-all',
  }

  if (styles) {
    style = {...style, ...styles}
  }

  const handleClose = () => {
    setOpen(false)
    setTimeout(() => {
      hideAcceptModal()
      onClose?.()
    }, 200)
  }

  const handleCloseStack = (ev: any) => {
    if (ev.target.id === 'base-stack2') {
      handleClose()
    }
  }
  return (
    <>
      <Modal
        id="modal-window2"
        aria-labelledby="transition-modal-title2"
        aria-describedby="transition-modal-description2"
        open={open}
        style={{zIndex: zIndex ?? '1300'}}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={open}>
          <Stack
            id="base-stack2"
            width="100%"
            height="100%"
            alignItems="center"
            justifyContent="center"
            position="relative"
            onClick={handleCloseStack}>
            <Stack
              direction="row"
              gap="7px"
              position="relative"
              style={stylesContainer}>
              <Box sx={style}>{children}</Box>
            </Stack>
            {firework && <Firework hide={handleClose} />}
          </Stack>
        </Fade>
      </Modal>
    </>
  )
}

export default ModalTranslation
